var _defs, _path, _path2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloud",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C3CBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D879B"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 50a12 12 0 0 1-1-24 16 16 0 0 1 30-3 13 13 0 0 1 1 27z",
    fill: "url(#cloud)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29a12 12 0 0 1 22-6",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 31,
    y: 44,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fontWeight: 800,
    fill: "#FFFFFF"
  }, "CO")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 47,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    fontWeight: 800,
    fill: "#FFFFFF"
  }, "2")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/co2.f8c8e565c863090e151c19f19662eb8a.svg";
export { ForwardRef as ReactComponent };